const GestaltColors = {
  green: '#0fa573',
  pine: '#0a6955',
  olive: '#364a4c',
  blue: '#0074e8',
  navy: '#004b91',
  midnight: '#133a5e',
  purple: '#b469eb',
  orchid: '#8046a5',
  eggplant: '#5b2677',
  maroon: '#6e0f3c',
  watermelon: '#f13535',
  orange: '#e3780c',
  darkGray: '#333',
  gray: '#8e8e8e',
  lightGray: '#efefef',
  red: '#e60023',
  white: '#fff',
};

export default GestaltColors;
